import React from "react";
import Modal from "react-bootstrap/Modal";
import CustomFormInput from "../CustomFormInput";
import { formatDateToLocalInput } from "../../helper/common";

function NotificationViewModal({ show, handleClose, selectedNotification }) {

  const typeObj = {
    all: "All User",
    student: "Student",
    teacher: "Teacher",
    teacherVerified: "Teacher(Verified)",
    selectedUser: "Selected Users",
  }

  const methodObj = {
    email: "Email only",
    inApp: "In-App Notification",
    both: "Both"
  }
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>View Notification</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CustomFormInput
          label="Notification Type"
          value={typeObj[selectedNotification?.type]}
          disabled
        />
        <CustomFormInput
          label="Title"
          value={selectedNotification?.title}
          disabled
        />
        <CustomFormInput
          as="textarea"
          type="text"
          label="Description"
          value={selectedNotification?.desc}
          disabled
        />

        <CustomFormInput
          label="Method"
          value={methodObj[selectedNotification?.method]}
          disabled
        />
        <CustomFormInput
          label="Schedule Time"
          value={selectedNotification?.scheduleTime !== null ? formatDateToLocalInput(selectedNotification?.scheduleTime) : '-'}
          disabled
        />
        <CustomFormInput
          label="Send"
          value={selectedNotification?.isSend === 1 ?
            'Yes'
            :
            'No'}
          disabled
        />
      </Modal.Body>
    </Modal>
  );
}

export default NotificationViewModal;
